import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  palette,
  lineHeights,
  fontSizes,
  fontWeights,
}: Theme) => ({
  title: {
    margin: '0 0 4px',
    fontSize: fontSizes.sm,
    fontWeight: fontWeights.medium,
    lineHeight: lineHeights.md,
    color: palette.text.primary,
  },
  param: {
    margin: '0',
    fontSize: fontSizes.xs,
    lineHeight: 1.4,
    color: palette.text.primary,
    '&:not(:last-child)': {
      marginBottom: 2,
    },
  },
  paramValue: {
    fontWeight: fontWeights.medium,
  },
  inline: {
    display: 'inline',
  },
  titleOrder: {
    margin: 0,
    marginRight: 3,
    color: palette.custom.greyNeutral,
    fontWeight: fontWeights.regular,
  },
  paramOrder: {
    color: palette.custom.greyNeutral,
  },
  paramItemOrder: {
    '&:last-child': {
      '& span:last-child': {
        display: 'none',
      },
    },
  },
  paramPropertyOrder: {
    textTransform: 'lowercase',
  },
}));
